import { generatePdf } from "./core";
export async function print(element, paramObj) {
    return generatePdf(element, "print", paramObj);
}
